import { Dropdown, Icon, IconButton } from '@monash/portal-react';
import { Controller, useFormContext } from 'react-hook-form';
import InlineErrorMessage from '../../../../common/inline-error-message/InlineErrorMessage';
import { LINKS_INLINE_ERROR_MSGS } from '../../constants';
import c from './personalisation-tag-input.module.scss';

const PersonalisationTagInput = ({
  index,
  removeTag,
  disabled,
  canRemove,
  availableOptions,
}) => {
  const {
    trigger,
    formState: { errors, isSubmitted },
  } = useFormContext();

  const fieldName = `personalisationTags.${index}.value`;
  const fieldError = errors.personalisationTags?.[index]?.value;
  const fieldErrorMsg = fieldError?.message;

  return (
    <>
      <div className={c.container}>
        <div className={c.dropdown}>
          <Controller
            name={fieldName}
            rules={{ required: LINKS_INLINE_ERROR_MSGS.PERSONALISATION_TAGS }}
            render={({ field: { value, onChange, onBlur } }) => (
              <Dropdown
                data={availableOptions}
                value={value}
                onBlur={onBlur}
                onChange={(selectedValue) => {
                  onChange(selectedValue);
                  isSubmitted && trigger(fieldName);
                }}
                disabled={disabled}
              />
            )}
          />
        </div>
        <IconButton
          icon={Icon.Trash}
          color="var(--card-text-color)"
          aria-label="Delete persona"
          onClick={removeTag}
          disabled={disabled || !canRemove}
        />
      </div>
      {fieldError && <InlineErrorMessage message={fieldErrorMsg} />}
    </>
  );
};

export default PersonalisationTagInput;
